import React, {useMemo} from "react";
import {Navigate, useLocation} from "react-router";
import {environment} from "../../env";
import {routes} from "../../routing/routes";
import {buildLoginRouteState, resolveLoginIntention} from "./LoginRouteState";
import {useAuth0Login} from "../auth0/useAuth0Login";
import {AuthLoadingScreen} from "../components/AuthLoadingScreen";
/** Rendered only when environment.hasAuth0 — safe to call useAuth0 unconditionally. */
export const RequireAuthWithAuth0: React.FC = () => {
    const location = useLocation();
    const auth0Only = !environment.hasMultipleAuthProviders;

    const loginIntention = useMemo(
        () => (auth0Only ? resolveLoginIntention(location, true) : null),
        [auth0Only, location],
    );

    const {isLoading, loginFailed, isLoggingIn, isMithraSyncing, isAuthenticated} = useAuth0Login({
        loginIntention,
        autoLogin: auth0Only,
    });

    const waitingForAuth0 = auth0Only && !loginFailed && (isLoggingIn || !isAuthenticated);

    if (isLoading || isMithraSyncing || waitingForAuth0) {
        return <AuthLoadingScreen/>;
    }

    const loginUrl = routes.login;
    return <Navigate
        to={loginUrl}
        replace
        state={buildLoginRouteState(location, location.pathname !== loginUrl)}
    />;
};
